/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2024-02-20 00:39:52
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2024-02-20 08:34:44
 * @FilePath: \xm-runing-main\src\utils\dateUtil.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Independent time operation tool to facilitate subsequent switch to dayjs
 */
import dayjs from 'dayjs';

export const dateUtil = dayjs;

export function formatToDateTime(date?: dayjs.ConfigType, format = 'YYYY-MM-DD HH:mm:ss'): string {
  return dayjs(date).format(format);
}
